var _path, _path2, _rect, _rect2, _path3, _rect3, _rect4, _circle, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHousingProtectServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 92,
    viewBox: "0 0 89 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.4986 43.1462L72.9316 12.21L52.8242 36.0279V91.4069H88.4986V43.1462Z",
    fill: "#5E676F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 41.9072H55.2008V91.4053H0.5V41.9072Z",
    fill: "#98A1A9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5254,
    y: 56.7588,
    width: 14.2698,
    height: 14.8494,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.0938,
    y: 61.707,
    width: 11.8915,
    height: 29.6988,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.703 12.21H19.1413L0.5 41.9088H55.2008L72.703 12.21Z",
    fill: "#1F2E3D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7812,
    y: 24.0996,
    width: 44.9589,
    height: 37.6093,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.4766,
    y: 38.2402,
    width: 5.56551,
    height: 15.7477,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.2618,
    cy: 38.2403,
    r: 6.41804,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9844 28.9376V11.9063C34.9844 6.93569 39.0138 2.90625 43.9844 2.90625H52.5331C57.5037 2.90625 61.5331 6.93569 61.5331 11.9062V28.9376",
    stroke: "#D9D9D9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHousingProtectServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcHousingProtectServiceMainMobile.278a9e07850e76ee366742d75aa588d2.svg";
export { ForwardRef as ReactComponent };